import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'

import { mixpanel } from '@/mixpanel'

function ProfileButton() {
  return (
    <Link to={'/profile'} onClick={() => mixpanel.track('profile_mobile_button_clicked')}>
      <FontAwesomeIcon fontSize={'25px'} fontWeight={300} icon={['fal', 'circle-user']} />
    </Link>
  )
}

export { ProfileButton }
